@if (searchResult$ | async; as searchResult) {
<div
  class="cx-search-facet"
  [class.side-nav]="sidenav === 'true'"
  [class.side-nav-firstlevel]="collapsedFacets?.size <= 0 && sidenav === 'true'"
  [class.side-nav-bottomlandscape]="bottomSpaceForMobileLandscape"
>
  <div
    class="cx-facet-filter-container"
    [class.sidenav-facet-filter-container]="sidenav === 'true'"
    [class.d-none]="collapsedFacets?.size > 0 && sidenav === 'true'"
  >
    <h4 class="cx-facet-filter-header">
      {{ 'product.productRefinement.filterResult.label' | cxTranslate }}
    </h4>
    <div class="filter-count-clear">
      <span class="filter-count">
        {{ 'product.productRefinement.items.items' | cxTranslate : { items: searchResult?.pagination?.totalResults } }}
      </span>
      @if (showClearFilter) {
      <span class="filter-clear" [class.d-none]="sidenav === 'true'">
        <button class="tertiary-btn" mat-button (click)="toggleValue('')">
          {{ 'product.productRefinement.clearFilters.title' | cxTranslate }}
        </button>
      </span>
      }
    </div>
    @if (searchResult.breadcrumbs?.length) { @for (breadcrumb of searchResult.breadcrumbs; track breadcrumb) {
    <div class="cx-facet-filter-pill" role="filter" [class.d-none]="breadcrumb.facetCode === 'category'">
      <span class="cx-facet-pill-value">{{ breadcrumb.facetValueName }}</span>
      <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="toggleValue(breadcrumb.removeQuery.query.value, null, null)"
      >
        <span aria-hidden="true">
          <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
        </span>
      </button>
    </div>
    } }
  </div>
  @if (visibleFacets$ | async; as visibleFacets) { @for (facet of visibleFacets; track facet; let facetId = $index) {
  @if (!isLeafCategory || facetId > 0) {
  <div
    class="cx-facet-group js-facet-group"
    [class.sidenav-facet-group]="sidenav === 'true'"
    [class.cx-facet-group-0]="facetId == 0"
    [class.d-none]="!isFacetCollapsed(facet.name) && collapsedFacets?.size > 0 && sidenav === 'true'"
    [class.facet-open]="isFacetCollapsed(facet.name) && sidenav === 'true'"
  >
    <!-- CATEGORY NO CHILDREN-->
    @if (facet?.visible) {
    <div class="cx-facet-header">
      <a
        class="cx-facet-header-link"
        (click)="toggleFacet(facet.name, facetId)"
        [attr.aria-expanded]="isFacetCollapsed(facet.name)"
        aria-controls=""
      >
        <span> {{ facet.name }} </span>
        <cx-icon [type]="!isFacetCollapsed(facet.name) ? iconTypes.EXPAND : iconTypes.COLLAPSE"></cx-icon>
      </a>
    </div>
    @if (isFacetCollapsed(facet.name)) {
    <ul class="cx-facet-list" [class.color-variant-wrapper]="(facet?.values)[0]?.image">
      @for (value of getVisibleFacetValues(facet); track value; let facetValueId = $index) {
      <li>
        @if (value?.image) {
        <div class="color-variant" [class.selected]="value.selected">
          <cx-media
            matTooltip="{{ value?.name }}"
            [matTooltipPosition]="'below'"
            matTooltipClass="image-tooltip"
            aria-label="Image that displays a tooltip in bottom"
            class="cx-product-image"
            [container]="getImageRendition(value?.image)"
            format="product"
            [alt]="value?.name"
            (click)="toggleValue(value.query.query.value, facet.name, value.name)"
            removeImageTitleAttr
          ></cx-media>
        </div>
        } @else {
        <div class="form-check">
          <label class="form-checkbox cx-facet-label">
            <input
              class="form-check-input cx-facet-checkbox js-facet-checkbox"
              role="checkbox"
              type="checkbox"
              aria-checked="true"
              [checked]="value.selected"
              (change)="toggleValue(value.query.query.value, facet.name, value.name)"
            />
            <span class="cx-facet-text">{{ value.name }} ({{ value.count }})</span>
          </label>
        </div>
        }
      </li>
      }
    </ul>
    } } @else {
    <!-- Hide as per GB2B-8604 and GB2B-8624-->
    <div class="cx-facet-header d-none">
      <a
        class="cx-facet-header-link"
        (click)="toggleFacet(facet?.name, facetId)"
        [attr.aria-expanded]="isFacetCollapsed(facet?.name)"
        aria-controls=""
      >
        <span> {{ facet?.name }} </span>
        <cx-icon [type]="!isFacetCollapsed(facet?.name) ? iconTypes.EXPAND : iconTypes.COLLAPSE"></cx-icon>
      </a>
    </div>
    @if (!isFacetCollapsed(facet?.name)) { @for (child of facet?.values; track child; let childId = $index; let last =
    $last) {
    <div class="facet-child" [class.facet-child-0]="childId == 0">
      <div>{{ child.name }}</div>
      <ul class="cx-facet-list" [class.last-classification]="last">
        @for (value of getVisibleFacetValues(child); track value; let facetValueId = $index) {
        <li>
          <div class="form-check">
            <label class="form-checkbox cx-facet-label">
              <input
                class="form-check-input cx-facet-checkbox"
                role="checkbox"
                type="checkbox"
                aria-checked="true"
                [checked]="value.selected"
                (change)="toggleValue(value.query.query.value, child.name, value.name)"
              />
              <span class="cx-facet-text">{{ value.name }} ({{ value.count }})</span>
            </label>
          </div>
        </li>
        } @if (showAllPerFacetMap.get(child.priority)) {
        <li class="cx-facet-toggle-btn" (click)="showLess(child.priority)">
          {{ 'product.productRefinement.showLess' | cxTranslate }}
        </li>
        } @if (!showAllPerFacetMap.get(child.priority) && child['values'].length > minPerFacet) {
        <li class="cx-facet-toggle-btn" (click)="showMore(child.priority)">
          {{ 'product.productRefinement.showMore' | cxTranslate }}
        </li>
        }
      </ul>
    </div>
    } } }
    <!-- CATEGORY HAS CHILDREN-->
  </div>
  } } }
</div>
}

<!-- SIDE NAV CLEAR FILTER BOTTOM-->
@if (sidenav === 'true') {
<div class="bottom-clear-filter">
  <button class="secondary-btn" mat-button (click)="toggleValue('')">
    {{ 'product.productRefinement.clearFilters.title' | cxTranslate }}
  </button>
</div>
}
